import { Chip } from './primitives/Chip';
import { Section } from './primitives/Section';
import { MonoKicker } from './primitives/MonoKicker';

const items = [
    'Calendaring & scheduling',
    'CRM & outreach',
    'Intake forms',
    'Referral tracking',
    'Results & follow-up queues',
    'Billing handoff',
    'Your EMR, whichever it is',
];

export function Roadmap() {
    return (
        <Section className="border-b border-border">
            <div className="flex flex-col gap-12">
                <div className="flex max-w-3xl flex-col gap-4">
                    <MonoKicker data-reveal>
                        Build 03 and every build after
                    </MonoKicker>
                    <h2
                        data-reveal
                        className="font-display text-[clamp(30px,4vw,40px)] leading-[1.15] text-balance"
                    >
                        Then we go looking for the next hour.
                    </h2>
                    <p
                        data-reveal
                        className="text-[clamp(16px,1.4vw,18px)] leading-[1.55] text-muted-foreground"
                    >
                        Once the notes are handled, the same team turns to
                        everything around them. We don&rsquo;t wait for a
                        feature request — we come back each quarter with what
                        we&rsquo;ve found, and you pick what gets built.
                    </p>
                </div>

                <div data-reveal className="flex flex-wrap gap-4">
                    {items.map((item) => (
                        <Chip key={item}>+ {item}</Chip>
                    ))}
                    <Chip tone="sageSolid">
                        + Whatever&rsquo;s eating your Thursdays
                    </Chip>
                </div>
            </div>
        </Section>
    );
}
